import * as React from 'react'
import { Form, Formik } from 'formik'
import { CampaignTrackingForm } from './CampaignTrackingForm'
import { useGetCallTrackingProviders } from '../hooks/useGetCallTrackingProviders'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { useSyncHandler } from '../hooks/useSyncHandler'
import * as yup from 'yup'
import { ContentCentered } from '@sales-center/components'
import { Theme } from '@mui/material/styles'

export function CampaignTrackingFormWrapper() {
  const { callTrackingProviderStatus, callTrackingProviders } =
    useGetCallTrackingProviders()

  const { handleSubmit } = useSyncHandler()

  const validationSchema = yup.object({
    accountId: yup
      .string()
      .required('Required')
      .max(100, `Account Id must be no more than 100 characters`),
    secretKey: yup
      .string()
      .required('Required')
      .max(100, `Secret Key must be no more than 100 characters`),
    accessKey: yup
      .string()
      .required('Required')
      .max(100, `Access Key must be no more than 100 characters`),
  })

  return (
    <>
      {callTrackingProviderStatus === 'pending' && (
        <Box
          sx={{
            paddingTop: (theme: Theme) => theme.spacing(4.8),
            textAlign: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {callTrackingProviderStatus === 'fail' && (
        <Box
          sx={{
            paddingTop: (theme: Theme) => theme.spacing(4.8),
            textAlign: 'center',
          }}
        >
          <Alert severity="info">
            Failed to load Call Tracking Account Data.
          </Alert>
        </Box>
      )}

      <ContentCentered>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: `${
              callTrackingProviders && callTrackingProviders.length > 3
                ? 'left'
                : 'center'
            } `,
            p: 2,
            maxWidth: '1320px',
            minWidth: '760px',
            marginLeft: 'auto',
            marginRight: 'auto',
            flexWrap: 'wrap',
          }}
        >
          {callTrackingProviderStatus === 'success' &&
            callTrackingProviders.map((x) => (
              <Box
                key={x.callTrackingProvider.name}
                sx={{
                  p: 2,
                  m: 1,
                }}
              >
                <Formik
                  key={x.id}
                  initialValues={{
                    accountId: x.callTrackingAccountId ?? '',
                    secretKey: '',
                    accessKey: '',
                    callTrackingProviderId: x.callTrackingProvider.id,
                  }}
                  onSubmit={handleSubmit}
                  validationSchema={validationSchema}
                >
                  <Form>
                    <CampaignTrackingForm
                      id={x.callTrackingProvider.id}
                      name={x.callTrackingProvider.name}
                      synced={x.synched}
                    ></CampaignTrackingForm>
                  </Form>
                </Formik>
              </Box>
            ))}
        </Box>
      </ContentCentered>
    </>
  )
}
